module.exports = __webpack_public_path__ + "static/media/ReceptionVenue.2f33dac9.png";